import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-gatewayint',
  templateUrl: './payment-gatewayint.component.html',
  styleUrls: ['./payment-gatewayint.component.scss']
})
export class PaymentGatewayintComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
